import { useApiClient } from '@/composables/useApiClient'
import type {
  WhatsappAnalysisStatus,
  WhatsappOperatorInsightsRequest,
  WhatsappOperatorInsightsResponse,
} from './interfaces/whatsapp-ai-analysis.interface'

export const useWhatsappAiAnalysisService = () => {
  const privateApi = useApiClient(true)

  const getAnalysisStatus = (chatId: string) =>
    privateApi.get<WhatsappAnalysisStatus>(
      `/v1/ia/whatsapp/chats/${chatId}/analysis-status`,
    )

  const getOperatorInsights = (chatId: string) =>
    privateApi.get<WhatsappOperatorInsightsResponse>(
      `/v1/ia/whatsapp/chats/${chatId}/operator-insights`,
    )

  const generateOperatorInsights = (
    chatId: string,
    payload: WhatsappOperatorInsightsRequest = {},
  ) =>
    privateApi.post<WhatsappOperatorInsightsResponse, WhatsappOperatorInsightsRequest>(
      `/v1/ia/whatsapp/chats/${chatId}/operator-insights`,
      payload,
    )

  return {
    generateOperatorInsights,
    getAnalysisStatus,
    getOperatorInsights,
  }
}
